//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uParse from '@/components/gaoyia-parse/parse.vue'
export default {
  name: 'ticket-detail',
  components: {
    uParse
  },
  props: {
    introduce: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkAll: false,
      checkAllUp: false,
      height: 0,
      // elRealheight: 0,
      // wHeight: 300
    }
  },
  watch: {
    introduce : {
      handler(val) {
        this.getHeight()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getHeight() {
      let _this = this
      // this.content = this.introduce
      setTimeout(() => {
        let dom = uni.createSelectorQuery().in(this).select('.detail')
        dom.fields({ size: true }, data => {
          _this.height = data.height
          if (data.height > 400) {
          // this.height = this.wHeight
          this.checkAll = true
          } else {
          // this.height = this.elRealheight
          this.checkAll = false
          }
        }).exec()
      }, 1000)
    }
  }
}
